import React from 'react'
import CenterModal from '../../../components/Modals/center-modal'
import SmallCenterModal from '../../../components/Modals/small-center-modal'
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as PendingIcon } from '../../../assets/plus_icon/incentive_pending.svg';
import { ReactComponent as PaidIcon } from '../../../assets/plus_icon/incentive_paid.svg';
import { ReactComponent as RightIcon } from '../../../assets/icons/righticon_primary.svg';
import moment from 'moment';

const SitevisitDetailsModal = ({ show, closeModal, selectedLead, setShowSitevisitModal, setShowReScheduleModal, projectIndex, setShowTimeline, setSelectedTimelineLead }) => {

    return (
        <SmallCenterModal show={show} closeModal={closeModal} dialogClassName='w-[400px] modal-radius'>
           <div className="!p-6">
    <div className="flex items-center justify-between !mb-4">
        <div className="h-12 w-12 rounded-xl bg-[#684EFB1A]/10 flex items-center justify-center">
            <LocationIcon className="fill-blue-900 h-12 w-12" />
        </div>
        <button className="border-0 bg-tr" onClick={closeModal}>
            <CloseIcon />
        </button>
    </div>
    <h3 className="text-lg font-semibold">
        Site Visit {!selectedLead.site_visits[0].is_completed ? 'Scheduled' : 'Completed'}
    </h3>
    <div className="border rounded-xl !py-2 !px-4">
        <div className="flex justify-between items-center text-sm !mt-3">
            <span className="text-black700">Project</span>
            <span>{selectedLead?.site_visits ? selectedLead.site_visits[0].project_name : '-'}</span>
        </div>
        <div className="border-t !my-4"></div>
        <div className="flex justify-between items-center text-sm">
            <span className="text-black700">SV Date & Time</span>
            <span>{moment(selectedLead?.site_visits[0]?.schedule_date).format('hh:mm a Do MMM YYYY')}</span>
        </div>
        <div className="border-t !my-4"></div>
        {/* Tagging Validity Section (Conditionally Rendered) */}
        {selectedLead?.site_visits[0]?.tagging_validity && (
            <div className="flex justify-between items-center text-sm">
                <span className="text-black700">Tagging validity</span>
                <span className="text-xs text-blue-900 bg-[#684EFB1A]/10 !py-1 px-2.5 font-bold rounded-2xl">
                    {`${selectedLead?.site_visits[0]?.tagging_validity} ${selectedLead?.site_visits[0]?.tagging_validity_unit}`}
                </span>
            </div>
        )}
        {selectedLead?.site_visits[0]?.tagging_validity && <div className="border-t !my-4"></div>}
        <div className="flex justify-between flex-col text-sm !mb-3">
            <span className="text-black700">Comments: </span>
            <span>{selectedLead?.site_visits[0]?.remarks || '-'}</span>
        </div>
        <div className="border-t !my-4"></div>
        <div className="flex justify-center items-center">
            <button
                className="text-blue-900 font-semibold text-xs flex items-center"
                onClick={() => {
                    setSelectedTimelineLead(selectedLead);
                    setShowTimeline(true);
                    closeModal();
                }}
            >
                Show SV Timeline
                <RightIcon className="fill-primary" />
            </button>
        </div>
    </div>
    <div className="space-x-3 flex items-center !mt-8">
        <button
            className={`${!selectedLead.site_visits[0].is_completed ? 'w-1/2' : 'w-full'} border rounded-xl py-2.5`}
            onClick={() => {
                setShowSitevisitModal(true);
                closeModal();
            }}
        >
            Add Projects
        </button>
        {!selectedLead.site_visits[0].is_completed && (
            <button
                className="w-1/2 border rounded-xl py-2.5 bg-blue-900 text-white"
                onClick={() => {
                    setShowReScheduleModal(true);
                    closeModal();
                }}
            >
                Re-schedule SV
            </button>
        )}
    </div>
</div>
        </SmallCenterModal>
    )
}

export default SitevisitDetailsModal